import a from "react";
import { getIconColor as r } from "./iconfont.es5470.js";
import f from "./iconfont.es5471.js";
const d = {
  display: "block"
}, g = ({ size: l = 16, useVw: t, useRem: n, color: c, withColor: o, removeClassName: e, disableSSR: m, style: i, ...p }) => {
  const x = i ? { ...d, ...i } : d;
  return /* @__PURE__ */ a.createElement(f, { disableSSR: m }, /* @__PURE__ */ a.createElement("svg", { "data-icon-id": "32px-diankaguanli", "data-icon-group": "GateHeader", "data-icon-version": "0.8.1", viewBox: "0 0 32 32", width: t ? ((l || 0) / 375 * 100).toFixed(5) + "vw" : l + (n ? "rem" : "px"), height: t ? ((l || 0) / 375 * 100).toFixed(5) + "vw" : l + (n ? "rem" : "px"), className: e ? "" : "iconpark-icon", style: x, fill: "none", ...p }, /* @__PURE__ */ a.createElement(
    "g",
    {
      className: e ? "" : "32px-ç¹å¡ç®¡ç"
    },
    /* @__PURE__ */ a.createElement(
      "g",
      {
        className: e ? "" : "normal",
        clipRule: "evenodd",
        fillRule: "evenodd",
        fill: o ? r(c, 0, "#262933") : "#262933",
        datafollowfill: o ? r(c, 0, "#262933") : "#262933"
      },
      /* @__PURE__ */ a.createElement(
        "path",
        {
          d: "M15.898 11.388c-.454-.994-1.867-.994-2.321 0l-.919 2.013-2.198.252c-1.086.124-1.522 1.468-.717 2.207l1.63 1.496-.44 2.168c-.217 1.072.926 1.902 1.878 1.364l1.926-1.088 1.927 1.088c.951.538 2.094-.293 1.877-1.364l-.44-2.168 1.63-1.496c.806-.739.37-2.083-.716-2.207l-2.198-.252-.92-2.013Zm-1.893 3.156.732-1.604.732 1.604a.85.85 0 0 0 .677.491l1.751.201-1.299 1.192a.85.85 0 0 0-.258.795l.35 1.728-1.535-.867a.85.85 0 0 0-.836 0l-1.535.867.35-1.728a.85.85 0 0 0-.258-.795l-1.299-1.192 1.752-.2a.85.85 0 0 0 .676-.492Z"
        }
      ),
      /* @__PURE__ */ a.createElement(
        "path",
        {
          d: "M4.85 8.34a3.964 3.964 0 0 1 3.964-3.963h11.234a3.964 3.964 0 0 1 3.964 3.963v.404L26.758 9.8a3.964 3.964 0 0 1 2.028 5.65l-4.782 8.46a3.964 3.964 0 0 1-3.956 3.713H8.814A3.964 3.964 0 0 1 4.85 23.66V8.34Zm17.362 1.042V8.341a2.164 2.164 0 0 0-2.164-2.164H8.814A2.164 2.164 0 0 0 6.65 8.34v15.32c0 1.195.969 2.163 2.164 2.163h11.234c1.19 0 2.156-.961 2.164-2.15V9.383Zm1.8 1.29v9.566l3.207-5.674c.65-1.15.126-2.61-1.107-3.084l-2.1-.808Z"
        }
      )
    )
  )));
}, h = g;
export {
  h as default
};
